import {
  useCategoriesFilterQuery,
  UseCategoriesFilterQueryParams,
} from "../queries/useCategoriesFilterQuery";
import { IPagination } from "../../../interfaces/IPagination";
import { CategoryInterface } from "../../../interfaces/categoryInterface";

type Response = {
  categories: CategoryInterface[];
  paginationData?: IPagination;
  isLoading: boolean;
};

export const useCategoriesFilter = (
  opt: UseCategoriesFilterQueryParams,
): Response => {
  const { data, isLoading } = useCategoriesFilterQuery(opt);
  return {
    categories: data?.data?.categories || [],
    paginationData: data?.data?.pagination,
    isLoading,
  };
};
